import { Fragment } from "react";
import { useSelector } from "react-redux";
import { ReportingWidget } from "./reportingwidget";
import { WIDGET_TICKER, getWidgetFontColors } from "./utils";
import { formatDate, dateFormats, formatNumber } from "../../lib/utils";


const TickerWidgetContent = props => {
    const {
        id, fontSize, fontIsBold, fontIsUnderline, fontIsItalic, fontColor, backgroundColor,
        data, schema, fields,
        ...other } = props;

    const currentTheme = useSelector(state => state.currentTheme);    
    const fontColors = getWidgetFontColors(currentTheme);
    let resolvedColor = fontColors.find(e => e.id == fontColor).color;

    //if dark theme and primary => use component text color instead
    if (currentTheme.darkTheme && resolvedColor == currentTheme.primary)
        resolvedColor = currentTheme.componentText;

     let values = [];

    if (data && data.length > 0)
    {
        data.forEach(row => {
            for (let f in fields)
            {       
                let field = fields[f];

                if (field.isVisible || field.IsVisible)
                {
                    let _schema = schema.find (e => e.Id == field.id || e.Id == field.Id);
                    let fieldName = _schema.Name || _schema.name;
                    let fieldTitle = _schema.Title || _schema.title;
                    let value = row[fieldName];
                    let resolvedData = value;
                    let resolvedColor = fontColors.find(e => e.id == fontColor).color;
               
                    if (currentTheme.darkTheme && resolvedColor == currentTheme.primary)
                        resolvedColor = currentTheme.componentText;

                    if (value == null)
                        resolvedData = "Null";
                    else if (_schema.DataTypeId == 2)            
                    {
                        resolvedData = formatNumber(value, 2);// ",");            
                        if (_schema.IsPercent)
                            resolvedData += "%";
                    }
                    else if (_schema.DataTypeId == 4 || _schema.DataTypeId == 5)                    
                        resolvedData = formatDate(value, dateFormats[1].title);                    
        
                    //handle variation

                    if (_schema.DataTypeId == 2 && (field.IsVariation || field.isVariation))
                    {
                        if (value < 0)
                        {
                            resolvedColor = _schema.IsVariationReverse ? currentTheme.success : currentTheme.error;
                            resolvedData = (<div style={{
                                            fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                                        }}>{fieldTitle + " : " + resolvedData}<span className='k-icon k-i-sort-desc-sm' style={{fontSize: fontSize}}></span> -</div>);
                        }
                        else if (value > 0)
                        {
                            resolvedColor = _schema.IsVariationReverse ? currentTheme.error : currentTheme.success;
                            resolvedData = (<div style={{
                                                fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                                            }}>{fieldTitle + " : " + resolvedData}<span className='k-icon k-i-sort-asc-sm' style={{fontSize: fontSize}}></span> -</div>);
                            //resolvedData = field.title + " : " + <resolvedData />;
                        }
                        else
                            resolvedData = <div style={{
                                                fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                                            }}>{fieldTitle + " : " + resolvedData + " -"}</div>;

                    }
                    else
                    {
                        resolvedData = <div style={{
                                                fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                                            }}>{fieldTitle + " : " + resolvedData + " -"}</div>;
                    }
        
                    values.push(resolvedData);
                }
            }
        });
    }

    return (
        <Fragment>
           <div className={`ticker-content ticker-content-${id}`} 
                style={{
                    fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                    backgroundColor: backgroundColor
                }}>           
                <Fragment>
                    <div className="ticker-container">
                        <div className="ticker-wrapper">
                            <div className="ticker-transition">
                            {
                                values.map((e,i) => (<div key={i} className="ticker-item">{e}</div>))
                            }
                            </div>
                        </div>
                    </div>                   
                </Fragment>            
            </div>
            <style>
                {
                    `
                        .ticker-content
                        {
                            text-align: center;       
                            flex: 1;
                            display: flex;
                            /*justify-content: center;*/
                            align-items: center;                   
                        }
                    `
                }
            </style>
        </Fragment>
    );
};


export const TickerWidget = props => {
    const {   
        id, mode, 
        loaded, loading, errorText, canceled,
        backgroundColor,title, titleFontSize, titleFontIsBold, titleFontIsUnderline, titleFontIsItalic, titleFontColor, 
        getContextMenu, onMenuItemClick,
        onWidgetSelect, onWidgetUnSelect, onDoubleClick, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);

    let duration = props.data && props.data.length > 0 ? props.data.length * props.fields.filter(e => e.isVisible || e.IsVisible).length * 4 + "s" : "20s";

    return (
        <Fragment>
            <ReportingWidget id={id} widgetTypeId={WIDGET_TICKER} dataSourceValueType={0} 
                mode={mode} loaded={loaded} loading={loading} errorText={errorText} canceled={canceled}
                backgroundColor={backgroundColor} title={title} titleFontSize={titleFontSize} titleFontIsBold={titleFontIsBold} 
                titleFontIsUnderline={titleFontIsUnderline} titleFontIsItalic={titleFontIsItalic} titleFontColor={titleFontColor} 
                getContextMenu={getContextMenu} onMenuItemClick={onMenuItemClick} 
                onWidgetSelect={onWidgetSelect} onWidgetUnSelect={onWidgetUnSelect} 
                onDoubleClick={onDoubleClick}>
                    <TickerWidgetContent currentTheme={currentTheme} {...props}/>
            </ReportingWidget>
           
            <style>
                {
                    `
                    .ticker-container {
                        width: 100%;
                        overflow: hidden;
                    }
                    .ticker-wrapper {
                        width: 100%;
                        padding-left: 100%;
                        background-color: transparent;
                    }

                    @keyframes ticker {
                        0% {
                            transform: translate3d(0, 0, 0);
                        }
                        100% {
                            transform: translate3d(-100%, 0, 0);
                        }
                    }
                    .ticker-transition {
                        display: inline-block;
                        white-space: nowrap;
                        padding-right: 100%;
                        animation-iteration-count: infinite;
                        animation-timing-function: linear;
                        animation-name: ticker;
                        animation-duration: ${duration};
                    }
                    .ticker-transition:hover {
                        animation-play-state: paused;
                        cursor: pointer;
                    }
                    .ticker-item {
                        display: inline-block;
                        padding: 0 8px;
                    }
                    `
                }
            </style>
        </Fragment>
    );
}